import { render, staticRenderFns } from "./InvoiceColumnsSelector.vue?vue&type=template&id=e8b68458"
import script from "./InvoiceColumnsSelector.vue?vue&type=script&lang=js"
export * from "./InvoiceColumnsSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports